module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_3500_Active@1x-65a97317561b43e73832395f32a362a3.png";